import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = {
  name: 'Sales',
  icon: 'mdi-chart-line',
  path: '/reports/sales/',
  children: [
    {
      path: '/reports/sales/salesLedger',
      name: 'Sales Ledger',
      meta: { id: 'reports-salesLedger' },
      component: () => import('./SalesLedger.vue'),
      ...addPermissionsToRoute(['salesLedger']),
    },
    {
      path: '/reports/sales/consolidatedSales',
      name: 'Consolidated Sales',
      meta: { id: 'reports-consolidatedSales' },
      component: () => import('./consolidatedSales/ConsolidatedSales.vue'),
      ...addPermissionsToRoute(['consolidatedSales']),
    },
    {
      path: '/reports/sales/salesDetail',
      name: 'Sales Detail',
      meta: { id: 'reports-salesDetail' },
      component: () => import('./SalesDetail.vue'),
      ...addPermissionsToRoute(['salesDetail']),
    },
  ]
};

export default routes;
